import { useFormContext } from "react-hook-form";
import React, { FC, useMemo } from "react";
import {
  ProductAttributes,
  useLazyFetchProductsJsonQuery,
} from "../../../../../Domains/Products/api/productJsonApi.ts";
import _ from "lodash";
import { AutocompleteProduct } from "@jamezz/react-components";
import { ChildProduct } from "./ChildProducts.tsx";
import { RenderOption } from "./AutocompleteProductRenderOption.tsx";
import { ExistingResourceObject } from "../../../../../Domains/Products/api/baseTypes.ts";

type AddChildProductProps = {
  append: (product: ChildProduct) => void;
  fields: ChildProduct[];
  replace: (products: ChildProduct[]) => void;
};
export const AddChildProduct: FC<AddChildProductProps> = ({ append, fields, replace }) => {
  const { menukaartVestigingId } = useFormContext();

  const values = useMemo(() => {
    return fields.map((field) => String(field.id));
  }, [fields]);

  const mapResultToChildProduct = (product: ExistingResourceObject<ProductAttributes>) => {
    return {
      type: "products",
      id: parseInt(product.id),
      naam: product.attributes.naam,
      prijs: product.attributes.prijs,
      sortkey: product.attributes.sortkey,
      pivot: {
        is_active_in_jamezz: product.attributes.is_actief,
        product_id: product.id,
        price: null,
        sort_key: null,
      },
    };
  };

  return (
    <AutocompleteProduct<true, ProductAttributes, true>
      multiple
      value={values}
      fetchQuery={useLazyFetchProductsJsonQuery}
      defaultFilters={{ vestiging_id: { field: "vestiging_id", operator: "=", value: menukaartVestigingId } }}
      menuSalesareaId={menukaartVestigingId}
      inputFieldProps={{ sx: { minWidth: 300 } }}
      onChange={(product) => {
        if (product && !Array.isArray(product)) {
          append(mapResultToChildProduct(product));
        } else if (product) {
          replace(_.map(product, (option) => mapResultToChildProduct(option)));
        }
      }}
      renderOption={(props, option) => <RenderOption option={option} />}
    />
  );
};
